module.exports = __webpack_public_path__ + "img/card-i3.873a2981.png";